import getEqualArrayItems from "./on-property-percents/get-equal-array-items";
import onOffsetHooks from "./on-property-percents/on-offset-hooks";
import onStatusCycle from "./percents/on-status-cycle";

/**
 *
 * @param {TemporaryDataProps} data
 * @param {StepProps  | TimelineMapProps} step
 * @param {Number} percents
 * @param {Boolean} enter
 */
const onIntervalStepStatus = (data, step, percents, enter) => {
  /** Start/Finish hooks */
  if (enter) {
    /** Enter started */
    if (percents === 0 && !step.get("started")) {
      onStatusCycle(step, enter, "start", "started", 1);
    }

    /** Enter finished */
    if (percents === 1 && !step.get("finished")) {
      onStatusCycle(step, enter, "finish", "finished", 0);
    }
  } else {
    /** Leave started */
    if (percents === 1 && !step.get("started")) {
      onStatusCycle(step, enter, "start", "started", 0);
    }

    /** Leave finished */
    if (percents === 0 && !step.get("finished") && step.get("is-active")) {
      onStatusCycle(step, enter, "finish", "finished", -1);
    }
  }

  /** Percentage hooks */
  if (step.get("has-offset-hook")) {
    onOffsetHooks(step, enter, percents, true);
  }
};

export default onIntervalStepStatus;
